import { type IWidgetType } from '../widgets/IWidgetType.ts';
import { type Widget } from '../widgets/Widget.ts';
import {
  type IWidgetDirectiveContext,
  type IWidgetDirectiveType,
} from './IWidgetDirectiveType.ts';

export interface IWidgetDirectivesInputProps {
  /** Direttive da rendere (gia' filtrate e ordinate). Vedi `useWidgetSupportedDirectives`. */
  directives: IWidgetDirectiveType<any>[];
  widget: Widget;
  widgetType: IWidgetType<Widget>;
}

const directiveContext: IWidgetDirectiveContext = {};

export function WidgetDirectivesInput(props: IWidgetDirectivesInputProps) {
  const { directives, widget, widgetType } = props;

  // TODO Al momento utilizziamo la configurazione per l'intero _widget_, ma
  // in realtà dovremmo farla per ogni _reference_.
  // Nessun wrapper DOM: i configComponent dichiarano da sé il proprio
  // WidgetConfigurationSlotRender, quindi qui l'output visivo è nullo.
  return (
    <>
      {directives.map(directive => {
        if (directive.configComponent == undefined) return null;
        return (
          <directive.configComponent
            key={directive.key}
            name={`directives.${directive.key}`}
            widget={widget}
            widgetType={widgetType}
            context={directiveContext}
          />
        );
      })}
    </>
  );
}
